// Per-user MRU of picked endpoints, stored in localStorage so it survives
// sign-in/sign-out cycles. Cap keeps the "Recent" box on endpointSelectionPage
// from ballooning; older entries fall off the tail.

const STORAGE_PREFIX = "recent-endpoints-";
const MAX = 5;

function key(uid: number): string {
  return `${STORAGE_PREFIX}${uid}`;
}

export function getRecentEndpointIds(uid: number): number[] {
  if (!uid || uid <= 0) return [];
  try {
    const raw = localStorage.getItem(key(uid));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((v) => typeof v === "number" && Number.isFinite(v) && v > 0);
  } catch {
    return [];
  }
}

export function pushRecentEndpointId(uid: number, id: number): void {
  if (!uid || uid <= 0 || !id || id <= 0) return;
  try {
    const current = getRecentEndpointIds(uid);
    const next = [id, ...current.filter((v) => v !== id)].slice(0, MAX);
    localStorage.setItem(key(uid), JSON.stringify(next));
  } catch {
    // localStorage quota / access failure — silently drop; this is cosmetic.
  }
}
